// src/lib/api-services-client.js — Phase A.7.2b PR1 admin (ADR-122)
//
// Helper client API api/services.js avec auth Bearer JWT.
// Cohérent avec callStripeAction (src/modals/_PaiementsTabBody.jsx L. 694).

import { supabase } from "../supabase";

/**
 * Appelle /api/services?action=X avec auth admin Bearer JWT.
 *
 * @param {string} action — action enum (ADMIN_ACTIONS ou PUBLIC_ACTIONS api/services.js)
 * @param {object} body — payload POST (ignoré pour GET)
 * @param {object} options
 * @param {boolean} options.requireAuth — true (défaut) inject Bearer admin
 * @param {string} options.method — 'GET' (utilise query) | 'POST' (utilise body). Défaut POST.
 * @param {object} options.query — query string params (encodés URL)
 * @returns {Promise<object>} payload JSON. Throws si http erreur.
 */
export async function callServicesAction(action, body = {}, options = {}) {
  const { requireAuth = true, method = "POST", query = {} } = options;

  const headers = {
    "Content-Type": "application/json",
  };
  if (requireAuth) {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session?.access_token) {
      throw new Error("Non authentifié");
    }
    headers.Authorization = `Bearer ${session.access_token}`;
  }

  // URL construction : action toujours en query, autres query params optionnels.
  const params = new URLSearchParams({ action, ...query });
  const url = `/api/services?${params.toString()}`;

  const fetchOptions = { method, headers };
  if (method !== "GET" && method !== "HEAD") {
    fetchOptions.body = JSON.stringify(body || {});
  }

  const res = await fetch(url, fetchOptions);
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.message || json.error || `http_${res.status}`);
    err.status = res.status;
    err.payload = json;
    throw err;
  }
  return json;
}
